import { Outlet } from 'react-router'
import { Header } from '../Header/index.ts'
import { Footer } from '../Footer/index.ts'
import { AlertContainer } from '@/components/alerts/index.ts'
import { BetaRibbon } from '@/components/ui/BetaRibbon/index.ts'
import DeadmanChatbot from '@/components/chatbot/DeadmanChatbot.tsx'

export function MainLayout() {
  return (
    <>
      <Header />
      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
      <AlertContainer />
      <DeadmanChatbot />
      <BetaRibbon />
    </>
  )
}
